/* ============================================
   PMD THEME — JavaScript
   ============================================ */

(function() {
  'use strict';

  /* --- Hero Slideshow --- */
  const Slideshow = {
    init() {
      const el = document.querySelector('.hero-slideshow');
      if (!el) return;

      this.container = el;
      this.track = el.querySelector('.hero-slideshow__slides');
      this.slides = el.querySelectorAll('.hero-slideshow__slide');
      this.dots = el.querySelectorAll('.hero-slideshow__dot');
      this.prevBtn = el.querySelector('.hero-slideshow__arrow--prev');
      this.nextBtn = el.querySelector('.hero-slideshow__arrow--next');
      this.current = 0;
      this.total = this.slides.length;
      this.interval = null;

      if (this.total <= 1) return;

      this.bindEvents();
      this.autoplay();
    },

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.goTo(i));
      });

      this.container.addEventListener('mouseenter', () => this.pause());
      this.container.addEventListener('mouseleave', () => this.autoplay());
    },

    goTo(index) {
      this.current = index;
      this.track.style.transform = `translateX(-${this.current * 100}%)`;
      this.dots.forEach((d, i) => d.classList.toggle('active', i === this.current));
    },

    next() {
      this.goTo((this.current + 1) % this.total);
    },

    prev() {
      this.goTo((this.current - 1 + this.total) % this.total);
    },

    autoplay() {
      this.pause();
      this.interval = setInterval(() => this.next(), 5000);
    },

    pause() {
      if (this.interval) clearInterval(this.interval);
    }
  };

  /* --- Search Overlay --- */
  const Search = {
    init() {
      this.overlay = document.querySelector('.search-overlay');
      if (!this.overlay) return;

      const openBtns = document.querySelectorAll('[data-search-open]');
      const closeBtn = this.overlay.querySelector('.search-overlay__close');

      openBtns.forEach(btn => btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      }));

      if (closeBtn) closeBtn.addEventListener('click', () => this.close());

      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    },

    open() {
      this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      const input = this.overlay.querySelector('.search-overlay__input');
      if (input) setTimeout(() => input.focus(), 100);
    },

    close() {
      this.overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  };

  /* --- Mobile Nav --- */
  const MobileNav = {
    init() {
      this.nav = document.querySelector('.mobile-nav');
      this.overlay = document.querySelector('.mobile-nav-overlay');
      if (!this.nav) return;

      const openBtn = document.querySelector('.mobile-menu-toggle');
      const closeBtn = this.nav.querySelector('.mobile-nav__close');

      if (openBtn) openBtn.addEventListener('click', () => this.open());
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    },

    open() {
      this.nav.classList.add('active');
      if (this.overlay) this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.nav.classList.remove('active');
      if (this.overlay) this.overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  };

  /* --- Product Page --- */
  const ProductPage = {
    init() {
      this.initGallery();
      this.initQuantity();
      this.initVariantSelect();
    },

    initGallery() {
      const thumbs = document.querySelectorAll('.product-gallery__thumb');
      const mainImg = document.querySelector('.product-gallery__main img');
      if (!thumbs.length || !mainImg) return;

      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const src = thumb.querySelector('img').getAttribute('data-full-src') ||
                      thumb.querySelector('img').src;
          mainImg.src = src;
          thumbs.forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        });
      });
    },

    initQuantity() {
      document.querySelectorAll('.quantity-selector').forEach(selector => {
        const minus = selector.querySelector('[data-qty-minus]');
        const plus = selector.querySelector('[data-qty-plus]');
        const input = selector.querySelector('input');

        if (minus) minus.addEventListener('click', () => {
          const val = parseInt(input.value) || 1;
          input.value = Math.max(1, val - 1);
        });

        if (plus) plus.addEventListener('click', () => {
          const val = parseInt(input.value) || 1;
          input.value = val + 1;
        });
      });
    },

    initVariantSelect() {
      const select = document.querySelector('[data-variant-select]');
      if (!select) return;

      select.addEventListener('change', () => {
        const selectedOption = select.options[select.selectedIndex];
        const price = selectedOption.getAttribute('data-price');
        const available = selectedOption.getAttribute('data-available');
        const priceEl = document.querySelector('.product-info__price');
        const addBtn = document.querySelector('.product-info__add-btn');

        if (priceEl && price) {
          priceEl.textContent = price;
        }

        if (addBtn) {
          if (available === 'false') {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
          } else {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }
        }
      });
    }
  };

  /* --- Cart --- */
  const Cart = {
    init() {
      this.drawer = document.querySelector('.cart-drawer');
      this.drawerOverlay = document.querySelector('.cart-drawer-overlay');

      const openBtns = document.querySelectorAll('[data-cart-open]');
      openBtns.forEach(btn => btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.openDrawer();
      }));

      const closeBtn = this.drawer?.querySelector('.cart-drawer__close');
      if (closeBtn) closeBtn.addEventListener('click', () => this.closeDrawer());
      if (this.drawerOverlay) this.drawerOverlay.addEventListener('click', () => this.closeDrawer());

      this.initAddToCart();
    },

    openDrawer() {
      if (this.drawer) this.drawer.classList.add('active');
      if (this.drawerOverlay) this.drawerOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    },

    closeDrawer() {
      if (this.drawer) this.drawer.classList.remove('active');
      if (this.drawerOverlay) this.drawerOverlay.classList.remove('active');
      document.body.style.overflow = '';
    },

    initAddToCart() {
      document.querySelectorAll('[data-add-to-cart]').forEach(form => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = form.querySelector('[type="submit"]');
          const originalText = btn.textContent;
          btn.textContent = 'Adding...';
          btn.disabled = true;

          try {
            const formData = new FormData(form);
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            });
            const data = await response.json();

            btn.textContent = 'Added!';
            this.updateCartCount();
            setTimeout(() => {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          } catch (err) {
            btn.textContent = 'Error';
            setTimeout(() => {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          }
        });
      });
    },

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        document.querySelectorAll('.header-icon__count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      } catch (err) {}
    }
  };

  /* --- Init --- */
  document.addEventListener('DOMContentLoaded', () => {
    Slideshow.init();
    Search.init();
    MobileNav.init();
    ProductPage.init();
    Cart.init();
  });
})();
